import { TemplateHistoryContextState } from '../context/TemplateHistoryContext';

export const dispatchTemplateId = (templateId: TemplateHistoryContextState['templateId']) =>
  ({
    type: 'setTemplateId',
    payload: { templateId },
  }) as const;

export const dispatchState = (
  isLoading: TemplateHistoryContextState['isLoading'],
  metadata: TemplateHistoryContextState['metadata'],
  refetch: () => void,
  template: TemplateHistoryContextState['template'],
  templateContentIds: TemplateHistoryContextState['templateContentIds'],
) =>
  ({
    type: 'setState',
    payload: { isLoading, metadata, refetch, template, templateContentIds },
  }) as const;

type actionTypes = ReturnType<typeof dispatchTemplateId> | ReturnType<typeof dispatchState>;

export const templateHistoryContextReducer = (
  state: TemplateHistoryContextState,
  action: actionTypes,
) => {
  switch (action.type) {
    case 'setTemplateId':
      return {
        ...state,
        templateId: action.payload.templateId,
      };
    case 'setState':
      return {
        ...state,
        isLoading: action.payload.isLoading,
        metadata: action.payload.metadata,
        refetch: action.payload.refetch,
        template: action.payload.template,
        templateContentIds: action.payload.templateContentIds,
      };
    default:
      return state;
  }
};
